// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1bZbE","tab":"ProcedureTabs_tab__2HkDs"};